import axios from "axios"; // The Axios library is used to transform object data to JSON Data
import appConfig from "../../config/app_config"; // The AppConfig is used to retrieve general info from the web
import { store } from "../store"; // The store library is used to retrieve dynamic stored data
import responseFromDss from './DssResponse'; // The dssResponse library is used to check the recieved data for success of error
// TODO <Translations into database, not in hard-coded files>
import { translateError } from '@/translation/native_translate.js'; // The native_translate library is used to read the errors and return the right translation


// Parameter 'cb' is the callback when function returns success
// Parameter 'ce' is the called when function returns error
// Parameter 'action' is the functionId for the dbLibFunction
// Parameter 'objectId' is the backend objectId to use as server
// Parameter 'args' is the payload for the db function
// Parameter 'timeout' is a timer for handling the function, default is 30000 (changed to 600000)
// Parameter 'showError' is a boolean flag that returns the error dialog from Linda

/* -- The doRequest recieves data from Vue Components in Object Data,
     pack the data in JSON Data and send this to the Backend.
     The doRequest recieves data from Backend in JSON Data,
     pack the data in Object Data and send this to the Vue components
 */
export function doRequest(cb, ce, action, objectId, args, timeout = 600000, showError = true) {
  // On each function the UserId and the AccountId are added to the arguments
  if (args.UserId === "" || args.UserId === undefined) {
    args.UserId = store.getters["auth/userName"];
  }
  args.LanguageTagId = store.getters.getUserLanguage === '' ? 13 : Number(store.getters.getUserLanguage);
  args.AccountId = store.getters.getCurrentAccountId;
  args.ApiVersion = 3;
  args.PartnerAdmin = 'Admin';

  const payload = {
    DssArguments: args,
    // FunctionDescription: functionDesc,
    ObjectId: objectId,
    Request: action
  };

  return axios({
    method: "post",
    url: appConfig.dss.url,
    timeout: timeout,
    headers: {
      Authorization: `Bearer ${store.getters["auth/token"]}`,
      "Content-Type": "application/json",
      "Access-Control-Allow-Headers": "*",
      Accept: "application/json"
    },
    data: payload,
  })
    .then((response) => {
      const dssResponse = new responseFromDss(response.data);

      if (dssResponse.success === true) {
        cb(dssResponse);
      } else {
        if (showError === true) {
          let errorMsg = 'E_00_00';

          if (dssResponse.data.ErrorMsg != null && dssResponse.data.ErrorMsg !== '') {
            errorMsg = dssResponse.data.ErrorMsg;
          }

          window.EventBus.fire(
            'triggerGenericErrorDialog',
            translateError(errorMsg),
          );

          // TODO this is a warning case, add warning dialog to triggerGenericErrorDialog
        } ce(dssResponse);
      }
    })
    // Catching the error, using the function translateError to retrieve the error message and calls the function activateErrorDialog to show the error dialog
    .catch(function (error) {
      if (showError === true) {
        window.EventBus.fire("triggerGenericErrorDialog", translateError('E_00_00'));
      }
      ce(error);
    });
}

// TODO <delete after adjustment at page : dssUtility.js (still being called on function createDSSRequest)
export function cleanupChild(cb, ce, parentId, payload) {
  doRequest(cb, ce, "cleanupChild", parentId, payload);
}
